import { WIDTHS } from "components/media/ImageCLD"

export default function srcSet(path, { env }) {
  const baseURL = new URL(path, `https://${env.cloudinary.secureDistribution}`)

  return WIDTHS.reduce((acc, width) => {
    const url = Object.assign(new URL(baseURL), { pathname: baseURL.pathname.replace("%w%", width) })
    if (acc.length) acc += ", "
    return acc += `${url.href} ${width}w`
  }, "")
}